<template>
	<v-container class="mt-12 pt-8" style="background:#fafafa;">
		<v-row style="background:#fafafa;">
			<v-col cols="12" class="pa-0">
				<v-row class="py-1 px-5" align="center" justify="center">
					<v-col cols="12" md="8" LeadsPannel>
						<v-card :loading="loading">
							<v-card-text class="py-0">
							</v-card-text>
							<v-row class="align-center">
								<v-col cols="12">
								</v-col>
							</v-row>

							<v-card-text>
								<v-row class="align-center">
									<v-col cols="12">

										<div v-if="subscription_active == false">
											<div style="text-align: center; margin: 40px; font-size: 22px;">
												<div>
													{{ arabic ? 'اشتراكك غير مفعل رجاء اختر خطة لاستخدام هذه الخدم' : 'Your subscription is not active. Please choose a plan to use this service.' }}
												</div>
												<v-btn color="primary" class="mt-3" style="width: 300px;" @click="navigateToPlanPrice">
													{{ arabic ? 'ترقية الخطة' : 'Plan Upgrade' }}
												</v-btn>
											</div>
										</div>

										<div v-else>


											<v-row class="align-center">
												<v-col cols="10">
													<div :class="`${arabic ? 'arFont' : 'enFont'} grey--text`">
														{{ i18n['updateForm'] }}</div>
												</v-col>
											</v-row>

											<v-form ref="form" @submit.prevent="submitForm">
												<v-card-text>
													<v-row>
														<v-col cols="6">
															<v-text-field outlined dense v-model="form.name" :label="i18n['fromNameInput']"
																:class="`${arabic ? 'arFont' : 'enFont'}`" required :rules="[rules.required]">
															</v-text-field>

														</v-col>
														<v-col cols="6">
															<v-text-field outlined dense v-model="form.title" :label="i18n['title']"
																:class="`${arabic ? 'arFont' : 'enFont'}`" required :rules="[rules.required]">
															</v-text-field>

														</v-col>
														<v-col cols="6">
															<v-text-field outlined dense v-model="form.description" :label="i18n['descriptionForm']"
																:class="`${arabic ? 'arFont' : 'enFont'}`" required>
															</v-text-field>

														</v-col>
														<v-col cols="6">
															<v-text-field outlined dense v-model="form.store_name" :label="i18n['store_name']"
																:class="`${arabic ? 'arFont' : 'enFont'}`" :rules="[rules.required, rules.storeName]"
																required>
															</v-text-field>
														</v-col>

														<v-col cols="6">
															<v-autocomplete outlined dense :items="languages" v-model="form.form_language"
																item-text="languageDisplay" item-value="value" :label="i18n['formLanguage']"
																:class="`${arabic ? 'arFont' : 'enFont'}`" required :rules="[rules.required]">
															</v-autocomplete>

														</v-col>
														<v-col cols="6">
															<v-autocomplete outlined dense :items="countries" v-model="form.country_id"
																item-text="name" item-value="id" :label="i18n['country']"
																:class="`${arabic ? 'arFont' : 'enFont'}`" required :rules="[rules.required]">
															</v-autocomplete>
														</v-col>
														<v-col cols="6">
															<v-text-field outlined dense v-model="form.success_url" :label="i18n['successURL']"
																:class="`${arabic ? 'arFont' : 'enFont'}`" :rules="[rules.url]"></v-text-field>
														</v-col>
														<v-col cols="6">
															<v-text-field outlined dense v-model="form.resubmit_block_duration" type="number"
																:label="i18n['resubmitBlockDuration']" min="1"
																:class="{'arFont': arabic, 'enFont': !arabic} ">
															</v-text-field>

														</v-col>
														<v-col cols="6">
															<v-text-field outlined dense v-model="form.call_center_note"
																:label="i18n['call_center_note']" :class="`${arabic ? 'arFont' : 'enFont'}`">
															</v-text-field>

														</v-col>
														<v-col cols="6">
															<v-text-field outlined dense v-model="form.submit_label" type="string"
																:label="i18n['submit_label']" min="1" :class="{'arFont': arabic, 'enFont': !arabic} "
																required :rules="[rules.required]"></v-text-field>

														</v-col>
														<v-col cols="6">
                                                                <v-switch v-model="form.prepaid_orders" :class="[{'arFont': arabic, 'enFont': !arabic},'mr-0']" :label="i18n['prepaid_orders']" color="success" dense inset>
                                                                </v-switch>
    
                                                            </v-col>
														<!-- style div  -->
														<template>
															<v-expansion-panels>
																<v-expansion-panel>
																	<v-expansion-panel-header>
																		{{ i18n['style_form'] }}
																	</v-expansion-panel-header>
																	<v-expansion-panel-content>
																		<!-- Submit Button Color -->
																		<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
																			transition="scale-transition" offset-y>
																			<template v-slot:activator="{ on, attrs }">
																				<v-text-field outlined dense :label="i18n['Submit_button_color']"
																					prepend-icon="color_lens" v-model="form.primary_color" v-bind="attrs" v-on="on">
																				</v-text-field>
																			</template>
																			<v-color-picker v-model="form.primary_color">
																			</v-color-picker>
																		</v-menu>

																		<!-- Button Font Color -->
																		<v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
																			transition="scale-transition" offset-y>
																			<template v-slot:activator="{ on, attrs }">
																				<v-text-field outlined dense :label="i18n['button_font_color']"
																					prepend-icon="text_format" v-model="form.button_font_color" v-bind="attrs"
																					v-on="on"></v-text-field>
																			</template>
																			<v-color-picker v-model="form.button_font_color">
																			</v-color-picker>
																		</v-menu>

																		<!-- Title Color -->
																		<v-menu ref="menu3" v-model="menu3" :close-on-content-click="false"
																			transition="scale-transition" offset-y>
																			<template v-slot:activator="{ on, attrs }">
																				<v-text-field outlined dense :label="i18n['title_color']" prepend-icon="title"
																					v-model="form.title_color" v-bind="attrs" v-on="on"></v-text-field>
																			</template>
																			<v-color-picker v-model="form.title_color">
																			</v-color-picker>
																		</v-menu>

																			<!-- Offer Color -->
																			<v-menu ref="menu4" v-model="menu4" :close-on-content-click="false"
																			transition="scale-transition" offset-y>
																			<template v-slot:activator="{ on, attrs }">
																				<v-text-field outlined dense :label="i18n['offer_color']" prepend-icon="title"
																					v-model="form.offer_color" v-bind="attrs" v-on="on"></v-text-field>
																			</template>
																			<v-color-picker v-model="form.offer_color">
																			</v-color-picker>
																		</v-menu>
																		
																		<!-- Title Font Size -->
																		<v-text-field outlined dense :label="i18n['title_font_size']"
																			prepend-icon="format_size" v-model="form.title_font_size"></v-text-field>

																	</v-expansion-panel-content>
																</v-expansion-panel>
															</v-expansion-panels>
														</template>
														<!--style div end -->
													</v-row>
													<!-- Dynamic fields section -->
													<v-row>
                                                        
														<v-col cols="6">

															<v-btn color="success" @click="addField" class="mb-2"
																:class="{'arFont': arabic, 'enFont': !arabic}" small>
																{{ i18n['addField'] }}</v-btn>

														</v-col>
														<v-col cols="6">
                                                                <div v-if="fields_prepiad_error!=''" style="color:red;">
                                                                            {{ arabic ? '   حقل المدينة والعنوان مطلوب ' : 'City and Address field is requird' }}
                                                                </div>
														</v-col>
														<v-col cols="6">
															<div v-if="fields_error!=''" style="color:red;">
																{{ arabic ? ' هذا الحقل مطلوب ' : 'The fields is required' }}

															</div>
														</v-col>
														
													</v-row>
													<v-expansion-panels accordion v-model="expandedPanel">
														<v-expansion-panel v-for="(field, index) in form.fields" :key="index" class="mb-2 mt-2">
															<v-expansion-panel-header :class="{'arFont': arabic, 'enFont': !arabic}">
																{{ i18n['Field'] }} {{ field.label }} {{ index + 1 }}
															</v-expansion-panel-header>
															<v-expansion-panel-content>
																<v-row>
																	<v-col cols="6">
																		<v-text-field outlined dense v-model="field.label" :label="i18n['fieldLabel']"
																			:class="`${arabic ? 'arFont' : 'enFont'}`" required :rules="[rules.required]">
																		</v-text-field>
																	</v-col>
																	<v-col cols="6">
																		<v-autocomplete outlined dense v-model="field.field_type"
																			:items="translatedFieldTypes" item-text="name" item-value="key"
																			:label="i18n['fieldType']" :class="`${arabic ? 'arFont' : 'enFont'}`" required
																			:rules="[rules.required]"
																			@change="onFieldTypeChange(field)"
																			>
																		</v-autocomplete>

																	</v-col>

																	<v-col cols="6">
																		<v-text-field outlined dense v-model="field.field_order" type="number"
																			:label="i18n['fieldOrder']" min="1"
																			:class="{'arFont': arabic, 'enFont': !arabic} ">
																		</v-text-field>

																	</v-col>

																	<v-col cols="6">
																		<v-switch v-model="field.is_required"
																			:class="[{'arFont': arabic, 'enFont': !arabic},'mb-2']"
																			:label="i18n['is_required']" color="success" dense inset
																			:disabled="isSwitchDisabled(field) || isSwitchDisabledPrePaid(field)"                               
																			>
																		</v-switch>
																	</v-col>
																	<v-col cols="6">
																		<v-btn x-small icon color="error" @click="removeField(index)">
																			<v-icon size="35">delete_forever</v-icon>
																		</v-btn>

																	</v-col>
																</v-row>
															</v-expansion-panel-content>
														</v-expansion-panel>
													</v-expansion-panels>
													<!-- Offers section -->
													<v-row>
														<v-col cols="6">
															<v-btn color="success" @click="addOffer" class="my-2"
																:class="{'arFont': arabic, 'enFont': !arabic}" small>
																{{ i18n['addOffer'] }}</v-btn>

														</v-col>
														<v-col cols="6">
															<div v-if="offers_error!=''" style="color:red;">
																{{ arabic ? ' هذا الحقل مطلوب ' : 'The fields is required' }}
															</div>
														</v-col>
													</v-row>
                                                    <!-- {{ offers }} -->
													<v-expansion-panels accordion v-model="expandedPanelOffers">
														<v-expansion-panel v-for="(offer, index) in offers" :key="`offer-${index}`"
															class="mb-2 mt-2">
															<v-expansion-panel-header :class="{'arFont': arabic, 'enFont': !arabic}">
																{{ i18n['offer'] }} {{ offer.label }} {{ index + 1 }}
															</v-expansion-panel-header>
															<v-expansion-panel-content>
																<v-col cols="12">
																	<v-text-field v-model="offer.label" :label="i18n['offerlabel']" required
																		:rules="[rules.required]" outlined dense>
																	</v-text-field>
																</v-col>
																<v-row>
																	<v-col cols="6">
																		<v-btn color="success" :class="[{'arFont': arabic, 'enFont': !arabic },'m-2']"
																			@click="addProductRow(index)" small>
																			{{i18n['addProduct']}} </v-btn>
																	</v-col>
																	<v-col cols="6">
																		<div v-if="products_error!=''" style="color:red">
																			{{ arabic ? ' هذا الحقل مطلوب ' : 'The fields is required' }}
																		</div>
																	</v-col>
																</v-row>
																<v-expansion-panels accordion v-model="expandedPanelOfferProducts">
																	<v-expansion-panel v-for="(productSetting, pIndex) in offer.products"
																		:key="`product-${pIndex}`" class="mb-2 mt-2">
																		<v-expansion-panel-header :class="{'arFont': arabic, 'enFont': !arabic}">
																			{{ i18n['product'] }}
																			<!-- {{ findProductName(product.id) +'---'+findProductSku(productSetting.id)}} -->
																			{{pIndex + 1  }}
																		</v-expansion-panel-header>
																		<v-expansion-panel-content>
																			<v-row>
																				<v-col cols="6">
                                                                                        <v-autocomplete 
                                                                                            outlined 
                                                                                            dense 
                                                                                            
                                                                                            :items="products" 
                                                                                            v-model="productSetting.product"
                                                                                            return-object 
                                                                                            :label="i18n['products']"
                                                                                            :class="{'arFont': arabic, 'enFont': !arabic}" 
                                                                                            required
                                                                                            item-text="item_name"
                                                                                            :filter="customFilter"
                                                                                            :rules="[rules.required]">
                                                                                            <template v-slot:selection="{ attr, on, item, selected }">
                                                                                                <span v-bind="attr" :input-value="selected" v-on="on"
                                                                                                    :class="`${arabic ? 'arFont' : 'enFont'}`">
                                                                                                        {{ item.item_name }} | {{ item.sku }}
                                                                                                </span>
                                                                                            </template>
                                                                                            <template v-slot:item="{ item }">
                                                                                                <span>
                                                                                                    {{ item.item_name }} | {{ item.sku }}
                                                                                                </span>
                                                                                            </template>
                                                                                        </v-autocomplete>

																				</v-col>
																				<v-col cols="6">
																					<v-text-field outlined dense v-model="productSetting.quantity" type="number"
																						:label="i18n['quantity']" min="1"
																						:class="{'arFont': arabic, 'enFont': !arabic} " required
																						:rules="[rules.required]">
																					</v-text-field>

																				</v-col>
																			</v-row>

																			<v-btn x-small icon color="error" @click="removeProductRow(index, pIndex)">
																				<v-icon size="35">delete_forever
																				</v-icon>
																			</v-btn>
																		</v-expansion-panel-content>
																	</v-expansion-panel>
																</v-expansion-panels>
																<v-row>
																	<v-col cols="6">
																		<v-autocomplete outlined dense :items="currencies" v-model="offer.currency"
																			:label="i18n['currency']" :class="{'arFont': arabic, 'enFont': !arabic}" required
																			:rules="[rules.required]">
																		</v-autocomplete>
																	</v-col>
																	<v-col cols="6">
																		<v-text-field outlined dense v-model="offer.price" :label="i18n['price']"
																			:class="{'arFont': arabic, 'enFont': !arabic}" required :rules="[rules.required]">
																		</v-text-field>
																	</v-col>
																	<v-col cols="6">
																		<v-switch v-model="offer.free_delivery"
																			:class="[{'arFont': arabic, 'enFont': !arabic},'mr-0']"
																			:label="i18n['free_delivery']" color="success" dense inset>
																		</v-switch>

																	</v-col>
																	<v-col cols="6">
																		<v-btn x-small icon color="error" @click="removeOffer(index)">
																			<v-icon size="35">delete_forever</v-icon>
																		</v-btn>
																	</v-col>
																</v-row>

															</v-expansion-panel-content>
														</v-expansion-panel>
													</v-expansion-panels>
												
													<v-row>
														<v-col cols="12">
															<v-switch v-model="form.tracking_status"
																:class="[{'arFont': arabic, 'enFont': !arabic},'mr-0']"
																:label="i18n['trackSocialMedia']" color="success" dense inset>
															</v-switch>
														</v-col>

													</v-row>
													<div v-if="form.tracking_status">
														<v-row>
															
															<v-col cols="6">
																<v-btn color="success" @click="addPlatform"
																	:class="{'arFont': arabic, 'enFont': !arabic}" small>{{ i18n['addPlatform'] }}</v-btn>
															</v-col>
															<v-col cols="6">
																<div v-if="platform_error !== ''" style="color:red">
																	{{ arabic ? ' هذا الحقل مطلوب ' : 'The fields is required' }}
																</div>
															</v-col>
														</v-row>
														<v-expansion-panels accordion class="mb-2 mt-2" v-model="expandedPanelPlatform">
															<v-expansion-panel v-for="(platformItem, index) in platforms" :key="index"
																class="platform-group mb-3">
																<v-expansion-panel-header :class="{'arFont': arabic, 'enFont': !arabic}">
																	{{ i18n['platform'] }}
																	{{ findPlatformName(platformItem.id) }}
																	{{ index + 1 }}</v-expansion-panel-header>
																<v-expansion-panel-content>
																	<v-row>
																		<v-col cols="6">
																			<v-autocomplete outlined dense v-model="platformItem.id" :items="platform"
																				item-value="id" item-text="name" class="" @change="() => {}"
																				:label="i18n['selectPlatform']" :class="{'arFont': arabic, 'enFont': !arabic}"
																				required :rules="[rules.required]">
																			</v-autocomplete>
																		</v-col>
																		<v-col cols="6">
																			<template>
																				<div>
																					<v-autocomplete v-if="!addingPixel" outlined dense
																						v-model="platformItem.pixel_id" :items="getFilteredPixels(platformItem.id)"
																						item-value="id" item-text="pixel_identifier" :label="i18n['selectPixel']"
																						:class="{'arFont': arabic, 'enFont': !arabic}" required
																						:rules="[rules.required]" append-outer-icon="mdi-plus"
																						@click:append-outer="addPixel(platformItem)">
																					</v-autocomplete>
																					<v-text-field v-else v-model="newPixelName" :label="i18n['newPixelName']"
																						:class="{'arFont': arabic, 'enFont': !arabic}" outlined dense required
																						:rules="[rules.required]" append-outer-icon="save"
																						@click:append-outer="saveNewPixel">
																					</v-text-field>
																				</div>
																			</template>
																		</v-col>
																		<v-col cols="6">
																			<v-autocomplete 
																				outlined 
																				dense 
																				v-model="platformItem.trigger" 
																				:items="triggerOptions" 
																				item-value="id" 
																				item-text="name" 
																				:label="i18n['selectTrigger']" 
																				:class="{'arFont': arabic, 'enFont': !arabic}" 
																				required 
																				:rules="[rules.required]"
																				></v-autocomplete>                                                                            
																		</v-col>
																		<v-col cols="6">
																			<v-autocomplete outlined dense v-model="platformItem.event_id"
																				:items="getFilteredEvents(platformItem.id)" item-value="id"
																				item-text="event_name" :label="i18n['selectEvent']"
																				:class="{'arFont': arabic, 'enFont': !arabic}" required
																				:rules="[rules.required]">
																			</v-autocomplete>
																			
																		</v-col>
																		
																		<v-col cols="6">
																			<v-btn x-small icon color="error" @click="removePlatform(index)">
																				<v-icon size="35">delete_forever
																				</v-icon>
																			</v-btn>
																		</v-col>
																	</v-row>
																</v-expansion-panel-content>
															</v-expansion-panel>
														</v-expansion-panels>
													</div>
												</v-card-text>
												<v-card-actions>
													<!-- {{form}} -->
												</v-card-actions>
												<v-card-actions>
													<v-btn small color="success" type="submit" block
														:class="{'arFont': arabic, 'enFont': !arabic}">
														{{ i18n['saveForm'] }}</v-btn>
												</v-card-actions>
											</v-form>
										</div>
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</v-container>
</template>


<script>
	// import axios from 'axios';

	export default {

		components: {
			// Form
		},
		data() {
			return {
				expandedPanel: -1, // Initially set to -1 to close all panels
				expandedPanelOffers: -1,
				expandedPanelOfferProducts: -1,
				expandedPanelPlatform: -1,
				fields_error: '',
				fields_prepiad_error:'',
				offers_error: '',
				products_error: '',
				platform_error: '',

				subscription_active: true,
				isLoading: true, // Initially true, since data is not yet loaded

				menu: false,
				form: {
					primary_color: '#9f0019',  
                    button_font_color: '#FFFFFF',    
                    title_color: '#9f0019',  
                    offer_color: '#9f0019',    
                    title_font_size: '24',       
					call_center_note: '',
					title: '',
					name: '',
					form_language: '',
					tracking_status: false,
					description: '',
					store_name: '',
					fields: [],
					country_id: null,
					offers: [],
					platforms: [],
					city_id: null,
					resubmit_block_duration: '',
					submit_label: '',
					prepaid_orders: false,


				},
				menu1: false, // For submit button color
				menu2: false, // For button font color
				menu3: false, // For title color
				menu4: false, // For Offer  color

				platform: [],
				free_delivery: false,
				offers: [],
				submit_label: '',
				name: '',
				label_offer: '',
				products: [],
				currencies: [],
				price: '',
				product: {
					product_id: '',
				},
				languages: [],
				countries: [],
				fieldTypes: [],
				field_order: '',
				success_url: '',
				is_required: false,
				platforms: [],
				events: [],
				successMessage: '',
				loading: true,
				trigger: null,
				triggerOptions: [
						{ id: 'page_view', name: 'On Form Page View' },
						{ id: 'submission', name: 'On Submission' },
						{ id: 'filling_form', name: 'On Starting to Fill Form' },
						{ id: 'thank_you_loading', name: 'On Thank You Loading' },
				],

				rules: {
					required: value => !!value || this.i18n['required'],
					string: value => (typeof value === 'string' || value instanceof String) || this.i18n[
						'mustBeAString'],
					number: value => !isNaN(parseFloat(value)) && isFinite(value) || this.i18n['mustBeANumber'],
					url: value => {
						if (!value) return true; // Allow empty input
						return /^(?:(?:https?:\/\/)?(?:www\.)?([a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,})|(?:www\.)?([a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}))(?:\/[^\s]*)?$/
							.test(value) || 'Invalid URL';
					},
					storeName: value => {
						const regex =
							/^[A-Za-z0-9\s]{1,20}$/; // Regex to allow 1-20 alphanumeric characters and spaces
						if (!value) {
							return this.i18n['required']; // Return the localized 'required' message if empty
						} else if (!regex.test(value)) {
							return this.i18n['store_name_invalid']; // Custom error message for invalid store name
						}
						return true; // Valid store name
					},

				},
				pixels: [],
				addingPixel: false,
				newPixelName: '',
				platformItem: {
					pixel_id: null,
				},
			};

		},
		watch: {
		},
		methods: {
            onFieldTypeChange(field) {
            if (field.field_type === "Name" || field.field_type === "FIRST_NUMBER_PHONE") {
                field.is_required = true;
            }
            if(this.form.prepaid_orders){
            if (field.field_type === "CITY" || field.field_type === "ADDRESS") {
                 field.is_required = true;
                }
            }
        },
        isSwitchDisabledPrePaid(field){
            if(this.form.prepaid_orders){
                return field.field_type === "CITY" || field.field_type === "ADDRESS";
            }
        },
        isSwitchDisabled(field) {

            return field.field_type === "Name" || field.field_type === "FIRST_NUMBER_PHONE";
        },
		    customFilter(item, queryText, itemText) {
        const searchText = queryText.toLowerCase();
        const sku = item.sku ? item.sku.toLowerCase() : ''; // Check if sku exists
        const itemName = item.item_name ? item.item_name.toLowerCase() : ''; // Check if item_name exists
        return sku.includes(searchText) || itemName.includes(searchText);
            },
			findProductSku(productId) {
				const product = this.products.find(p => p.id === productId);
				return product ? product.sku : '';
			},
			findProductName(productId) {
				const product = this.products.find(p => p.id === productId);
				return product ? product.item_name : '';
			},
			findPlatformName(platformId) {
				const platform = this.platform.find(p => p.id === platformId);
				return platform ? platform.name : '';
			},
			submitForm() {
				if (!this.$refs.form.validate()) {
					console.error("Form validation failed");
					return;
				}

				 

				if (this.form.fields.length <= 0) {
					this.fields_error = "fields is empty please enter fields";
					console.log('fields is empty', this.form.fields.length)
					return;
				}

			if (this.form.prepaid_orders) {
				
					const requiredFields = ['CITY', 'ADDRESS'];
					const selectedFields = this.form.fields.map(field => field.field_type);
					console.log("Selected Fields: ", selectedFields);
					const missingFields = requiredFields.filter(field => !selectedFields.includes(field));
					console.log("Missing Fields: ", missingFields);

					if (missingFields.length > 0) {
						this.fields_prepiad_error = 'City and Address fields are required';
						console.log(this.fields_prepiad_error);
						return;
					} else {
						this.fields_prepiad_error = ''; 
					}
				}else{
					this.fields_prepiad_error = ''; // Clear the error if conditions are met

				}

				if (this.offers.length <= 0) {
					this.offers_error = "Offers is is empty please enter Offers";
					console.log('offers is empty', this.offers.length)
					return;
				}

				if (this.products_error != '') {
					console.log('the product is empty')
					return;
				}

				if (this.form.tracking_status === true && this.platforms.length <= 0) {
					this.platform_error = 'Error: Please add platforms.';
					console.log(this.platform_error);
					return;
				} else {
					this.platform_error = '';
				}

				this.loading = true;

				// Prepare the form data including platforms and offers directly
				// console.log(this.form);
                this.form.form_offers = this.offers

				const formData = {
					...this.form,
					
					platforms: this.platforms, // Assuming this.platforms holds the updated platforms array
					offers: this.offers, // Assuming this.offers holds the updated offers array
					pixels: this.pixels || [], // Include pixels if it's part of your form, ensure this.pixels is defined
                    trigger:this.trigger,


				};
				 console.log(' data:', formData);

				// Dispatch the Vuex action to update the form data
				this.$store.dispatch('putResource', {
						resource: `/updateDataForm/${this.$route.params.id}`,
						value: formData
					})
					.then(response => {
						this.successMessage = 'Form updated successfully!';
						//console.log(response.data);
						this.loading = false;
						this.$router.push({
							name: 'form_list'
						});
					})
					.catch(error => {
						console.error("There was an error updating the form data:", error);
						this.loading = false;
					});
			},
			// showPixel
			async fetchDataPixels() {
				try {
					const response = await this.$store.dispatch('getResource', {
						resource: '/getPixels'
					});

					const {
						pixels
					} = response.data;
					this.pixels = pixels;
					console.log(this.pixels);
				} catch (error) {
					console.error("Error fetching data:", error);
				}
			},
			getFilteredPixels(id) {
				return this.pixels.filter(pixel => pixel.platform_id === id);
			},
			addPixel(platformItem) {
				this.addingPixel = true;
				this.platformItem = platformItem;
			},
			async saveNewPixel() {
				const newPixelData = {
					platform_id: this.platformItem.id,
					pixel_identifier: this.newPixelName,
				};
				console.log(newPixelData)

				try {
					const response = await this.$store.dispatch('postResource', {
						resource: '/storePixel',
						value: newPixelData
					});
					console.log("Successfully added new pixel:", response);
					this.fetchDataPixels();
					this.addingPixel = false;
					this.newPixelName = '';
				} catch (error) {
					console.error("Failed to add new pixel:", error);
					this.addingPixel = false;

					if (error.response) {
						console.log(error.response.data);
						console.log(error.response.status);
					} else if (error.request) {
						console.log(error.request);
					} else {
						console.log('Error', error.message);
					}
				}
			},
			async fetchData() {
				try {
					const response = await this.$store.dispatch('getResource', {
						resource: '/DataFormBuilder'
					});
					const {
						countries,
						languages,
						fieldTypes,
						currencies,
						products,
						platform,
						events,
						cities
					} = response.data;
                    
					this.countries = countries;
					this.languages = languages;
					this.fieldTypes = fieldTypes;
					this.currencies = currencies;
					this.products = products;
					this.platform = platform;
					this.events = events;
					this.allCities = cities;

					// console.log(this.fieldTypes);
				} catch (error) {
					console.error("Error fetching data:", error);
				}
			},
            async fetchFormData() {
      try {
        const response = await this.$store.dispatch('getResource', {
          resource: `/showDataForm/${this.id}`
        });

        if (response.subscription_active == '') {
          // Handle empty subscription_active case if needed
        } else {
          this.subscription_active = response.subscription_active;
          console.log(response.subscription_active);
        }

        this.isLoading = false;
        this.loading = false;

        this.form = response.data.form;
        this.subscription_status = response.subscription_active;
        this.offers = this.form.form_offers || [];

        this.platforms = this.form.form_tracking_setups.map(x=>({...x, id:x.platform_id})) || [];
        this.products = this.products || [];
        this.tracking_status = this.form.tracking_status;
        //console.log(this.tracking_status);

        // Transform offers to extract products
        this.offers = this.form.form_offers.map(offer => ({
            ...offer,
            products: offer.form_offer_products.map(prod => ({
                quantity: prod.quantity,
                product: prod.product // Ensure the product_id is included
            }))
        }));

        // Flatten products from all offers
        const offerProducts = this.offers.flatMap(offer => offer.products.map(p => p.product));
        this.products = [...this.products, ...offerProducts]; 
        this.products = this.products.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i);

         console.log(this.platforms);

        this.fields = this.form.fields.map(field => ({
            ...field,
            field_type: field.field_type,
        }));
    } catch (error) {
        console.error("Error fetching form data:", error);
        this.isLoading = false;
        this.loading = false;
    }
             },
			addField() {
				this.fields_error = '';

				// Add a new field to the form.fields array
				this.form.fields.push({
					label: '',
					value: '',
					type: '',
					field_order: '',
				});

				this.expandedPanel = this.form.fields.length - 1;

				if (!this.form.fields) {
					this.form.fields = [];
				}
				if (this.form.fields.length >= 0 && this.form.fields[0].label === '') {
					console.log('The first field is empty');
					return;
				}
			},
			removeField(index) {
				this.form.fields.splice(index, 1);
			},
			languageDisplay(lang) {
				return lang === 'ar' ? 'Arabic' : 'English';
			},
			addOffer() {
				this.offers_error = '';
				this.products_error = 'error';

				this.offers.push({
					label_offer: '',
					products: [],
					currency: '',
					price: '',
					free_delivery: false
				});
				this.expandedPanelOffers = this.offers.length - 1;

			},
			addProductRow(offerIndex) {
				this.products_error = '';
				this.offers[offerIndex].products.push({
					product: null,
					quantity: 1,

				});
				this.expandedPanelOfferProducts = this.offers[offerIndex].products.length - 1;


			},
			removeProductRow(offerIndex, productIndex) {
				if (this.offers[offerIndex] && this.offers[offerIndex].products) {

					this.offers[offerIndex].products.splice(productIndex, 1);
				}
			},
			removeOffer(index) {
				this.offers.splice(index, 1);
			},
			addPlatform() {
				this.platform_error = '';
				this.platforms.push({
					id: null,
					event_id: null,
				});
				this.expandedPanelPlatform = this.platforms.length - 1;
			},
			removePlatform(index) {
				this.platforms.splice(index, 1);
			},
			getFilteredEvents(id) {
				console.log(id)
				console.log(this.events)
				return this.events.filter(event => event.platform_id === id);
			},

			navigateToPlanPrice() {
				this.$router.push({
					name: 'plan_price'
				});
			}

		},
		computed: {
			language() {
				return this.$store.state.language;
			},
			i18n() {
				return this.$store.state.i18n[this.$store.state.language];
			},
			arabic() {
				if (this.$store.state.language == "ar")
					return true;
			},
			filteredEvents() {
				return this.events.filter(event => event.platform_id === this.id);
			},

			translatedFieldTypes() {
				return this.fieldTypes.map(type => ({
					key: type, // Original key
					name: this.i18n.fieldsType[type] || type // Translation or default to key
				}));
			},
		},

		mounted() {
			this.fetchDataPixels();
			this.fetchData(); // Fetches dropdown data and such
			this.id = this.$route.params.id; // Sets the ID from the URL parameter
			if (this.id) {
				this.fetchFormData(); // Fetches the form data if an ID is present
			}
		},

	}
</script>